import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- entities
import ProductCategory from 'PMT/entities/menu/ProductCategory';

class ProductDetailCategoryRow extends Component {

  static propTypes = {
    category: PropTypes.instanceOf(ProductCategory).isRequired
  };


  shouldComponentUpdate(nextProps) {
    return !nextProps.category.equals(this.props.category);
  }

  onDisplayDetailClick = () => {
    RouteAction.presentCategoryDetail(this.category);
  };

  get category() {
    return this.props.category;
  }

  // -- renderers

  render() {
    return (
      <li
        onClick={this.onDisplayDetailClick}
      >
        <h4 className="link-hover">
          {this.category.name}
        </h4>
      </li>
    );
  }

}

export default ProductDetailCategoryRow;
